export default __webpack_public_path__ + "static/devkit-b06712e3b535654ea00c84cc475a42ff.png";